import styled from "styled-components";

export const AreaButtons = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: flex-end;
	align-items: flex-start;
	gap: 1rem;
`;

export const Container = styled.div`
	display: grid;
	grid-template-columns: repeat(3, 1fr);
	grid-template-rows: auto;
	gap: 1rem;

	> ${AreaButtons} {
		grid-column: 3 / 3;
	}

	@media (max-width: ${({ theme }) => theme.breakpoints.desktopSmall}) {
		grid-template-columns: repeat(2, 1fr);

		> ${AreaButtons} {
			grid-column: 2/2;
		}
	}

	@media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
		display: flex;
		flex-direction: column;

		> ${AreaButtons} {
			flex-direction: column;

			> button {
				width: 100%;
				max-width: 100%;
			}
		}
	}
`;

export const RowInputs = styled.div`
	display: grid;
	grid-template-columns: 1fr 1fr 1fr;
	gap: 1rem;
	margin-bottom: 1rem;

	@media (max-width: 560px) {
		grid-template-columns: 1fr;
	}
`;
